let module = angular.module('app.resources');

module.factory('TwitterUser', ($resource) => {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/twitter_users/:id`,
    { id: '@id' },
    {
      query: {
        method: 'GET',
        isArray: true,
      },
      create: { method: 'POST' },
      delete: { method: 'DELETE' },
      update: { method: 'PUT' },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/twitter_user.js